import { loadImage } from './img'
import { tr } from '../i18n'

/**
 * Карточка превью 1200×630 для WhatsApp/Telegram. Рисуется на клиенте в момент
 * отправки — холст уже здесь, серверу растеризатор не нужен. Слева рисунок,
 * справа — кто спрашивает и что. Ужимается в JPEG, чтобы не раздувать сообщение.
 */
export async function renderOgCard(p: { img: string; who: string; question: string | null }): Promise<string> {
  const t = tr()
  const W = 1200
  const H = 630
  const c = document.createElement('canvas')
  c.width = W
  c.height = H
  const g = c.getContext('2d')!

  g.fillStyle = '#F6F5F1'
  g.fillRect(0, 0, W, H)

  // рисунок в рамке слева
  const img = await loadImage(p.img)
  const box = { x: 48, y: 48, w: 534, h: H - 96 }
  g.fillStyle = '#fff'
  g.strokeStyle = '#D8D6CE'
  g.lineWidth = 3
  rr(g, box.x, box.y, box.w, box.h, 28)
  g.fill()
  g.stroke()
  const sc = Math.min((box.w - 24) / img.width, (box.h - 24) / img.height)
  const iw = img.width * sc
  const ih = img.height * sc
  g.drawImage(img, box.x + (box.w - iw) / 2, box.y + (box.h - ih) / 2, iw, ih)

  // текст справа
  const tx = 640
  const tw = W - tx - 56
  g.textAlign = 'left'
  g.fillStyle = '#16181D'
  g.font = "600 30px 'Unbounded', system-ui, sans-serif"
  const [a, b, cc] = t.logo
  let x = tx
  g.fillText(a, x, 108)
  x += g.measureText(a).width
  g.fillStyle = '#3347E0'
  g.fillText(b, x, 108)
  x += g.measureText(b).width
  g.fillStyle = '#16181D'
  g.fillText(cc, x, 108)

  let y = 220
  if (p.who) {
    g.fillStyle = '#5A5D66'
    g.font = "500 30px 'Golos Text', system-ui, sans-serif"
    g.fillText(p.who, tx, y)
    y += 64
  }
  g.fillStyle = '#16181D'
  g.font = "600 46px 'Unbounded', system-ui, sans-serif"
  y = wrap(g, p.question ?? t.dialogs.titleDefault, tx, y, tw, 60)

  g.fillStyle = '#3347E0'
  g.font = "500 30px 'Golos Text', system-ui, sans-serif"
  wrap(g, t.share.ogSubtitle, tx, y + 36, tw, 40)

  g.fillStyle = '#5A5D66'
  g.font = "500 24px 'Golos Text', system-ui, sans-serif"
  g.fillText('liniya.org', tx, H - 60)

  return c.toDataURL('image/jpeg', 0.82)
}

function rr(g: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number) {
  g.beginPath()
  g.moveTo(x + r, y)
  g.arcTo(x + w, y, x + w, y + h, r)
  g.arcTo(x + w, y + h, x, y + h, r)
  g.arcTo(x, y + h, x, y, r)
  g.arcTo(x, y, x + w, y, r)
  g.closePath()
}

function wrap(g: CanvasRenderingContext2D, text: string, x: number, y: number, maxW: number, lh: number): number {
  const words = text.split(' ')
  let line = ''
  let lines = 0
  for (const w of words) {
    const test = line ? line + ' ' + w : w
    if (g.measureText(test).width > maxW && line) {
      g.fillText(line, x, y)
      y += lh
      line = w
      if (++lines >= 4) { g.fillText('…', x, y); return y + lh }
    } else line = test
  }
  if (line) { g.fillText(line, x, y); y += lh }
  return y
}
